import React from 'react'

// Copied directly from Figma, removed sizes

export const selectedFilterId = 'filter0_d_9450_11523'
export const selectedFilter = (
  <filter
    id={selectedFilterId}
    filterUnits="userSpaceOnUse"
    colorInterpolationFilters="sRGB"
  >
    <feFlood floodOpacity="0" result="BackgroundImageFix" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feOffset />
    <feGaussianBlur stdDeviation="1.5" />
    <feComposite in2="hardAlpha" operator="out" />
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 1 0"
    />
    <feBlend
      mode="normal"
      in2="BackgroundImageFix"
      result="effect1_dropShadow_9450_11523"
    />
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="effect1_dropShadow_9450_11523"
      result="shape"
    />
  </filter>
)

export const hoverFilterId = 'filter0_d_9478_13740'

export const hoverFilter = (
  <filter
    id={hoverFilterId}
    filterUnits="userSpaceOnUse"
    colorInterpolationFilters="sRGB"
  >
    <feFlood floodOpacity="0" result="BackgroundImageFix" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feOffset />
    <feGaussianBlur stdDeviation="1.5" />
    <feComposite in2="hardAlpha" operator="out" />
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 0.944368 0 0 0 0 0 0 0 0 0 0 0 0 0 0.41 0"
    />
    <feBlend
      mode="normal"
      in2="BackgroundImageFix"
      result="effect1_dropShadow_9478_13740"
    />
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="effect1_dropShadow_9478_13740"
      result="shape"
    />
  </filter>
)
